<template>
  <div v-if="totalCount > 0" class="text-xs mb-4">
    {{ totalCountText }}
  </div>
</template>

<script>

import searchFactory from '@/compositions/search/SearchFactory'
import searchConfig from '@/compositions/search/SearchConfiguration'

import { computed } from 'vue'

export default {
  setup() {
    const { totalCount } = searchFactory.useSearchResult()
    const { getActiveConfig } = searchConfig.searchConfigurationUse()

    return {
      totalCount,
      totalCountText: computed(() => getActiveConfig().translations.totalCountMessage.replace('{0}', totalCount.value))
    }
  }
}
</script>
